import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';

const _url = Symbol();

class VideoDialogContent extends BaseElement {
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				.container {
					text-align: center;
				}
				.container video {
					max-width: 100%;
					max-height: 100%;
				}
			`
		];
	}
	get url() {
		return this[_url];
	}
	set url(v) {
		if(typeof v !== 'string')
			throw new TypeError('url must be a string.');
		this[_url] = v;
		this.requestUpdate();
	}
	render() {
		return html`
			<div class="container">
				<video src="${this.url}" controls autoplay></video>
			</div>
		`;
	}
}

customElements.define('pp-video-dialog-content', VideoDialogContent);